import React, { ComponentPropsWithoutRef } from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import classNames from 'classnames';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.marginBase * 2,
    padding: theme.marginBase * 2,
    marginBottom: theme.marginBase * 2,
    borderRadius: theme.borderRadius.std,
    cursor: 'default',
    backgroundColor: theme.colors.grayBackground,
    minHeight: 60,
  },
  selectable: {
    cursor: 'pointer',
    border: {
      width: 1,
      style: 'solid',
      color: theme.colors.grayBorder,
    },
    backgroundColor: theme.colors.white,
  },
  selected: {
    backgroundColor: theme.colors.grayBackground,
    borderColor: theme.colors.green,
  },
}));

interface Props {
  selected?: boolean;
  selectable?: boolean;
  className?: string;
}

export const PaymentMethodContainer = ({
  selected,
  selectable,
  className,
  ...props
}: Props & ComponentPropsWithoutRef<'div'>) => {
  const classes = useStyles();
  return (
    <div
      className={classNames(className, classes.container, {
        [classes.selectable]: selectable,
        [classes.selected]: selected,
      })}
      {...props}
    />
  );
};
